import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import Photo from "./photo/index";
import Dropdown from "./dropdown/index";
import templates from "../../../utils/templates";

const channel = Radio.channel("global");

const DEFAULTS = {
  className: "nav-item dropdown avatar-wrapper",
  template: templates.find("masthead", "avatar"),
};

class Avatar extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      photo: ".dropdown-toggle",
      dropdown: "nav",
    };
  }

  initialize() {
    this.user = channel.request("auth:user");
    this.user.setFullName(channel.request("user:name"));
  }

  onRender() {
    this.photo.show(
      new Photo({
        url: this.user.getPhotoURL(),
        name: this.user.getFullName(),
      })
    );

    this.dropdown.show(
      new Dropdown({
        user: this.user,
      })
    );
  }
}

export { Avatar as default };
